import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import ClientActivityCard from "./ClientActivityCard";
import { onClientActivity } from "common/signalR";

interface Props {
  clientId: number
  config: server.dto.ActivityPanelConfig
}

const ClientActivityPanel = (props: Props) => {
  const { clientId, config } = props;

  return <ActivityPanel<server.dto.ClientActivity>
    config={config}
    fetchActivities={(page, perPage) => window.CoreApi.Client.ListActivity({ page, perPage, itemId: clientId })}
    renderActivity={(activity) => <ClientActivityCard key={activity.activityId} activity={activity} />}
    onActivityRegisterFn={onClientActivity}
    onActivity={() => ({ refreshActivities: true })}
  />;
};

export default ClientActivityPanel;